export enum ProviderType {
  SENSORS = 'sensors',
  FACEBOOK = 'facebook',
  GA4 = 'ga4',
  TIKTOK = 'tiktok',
  APPLOVIN = 'applovin',
  BING = 'bing',
  CRITEO = 'criteo',
  PEPPERJAM = 'pepperjam',
  SNAPCHAT = 'snapchat',
  SNAPCHAT_CONVERSION = 'snapchat_conversion',
  TTD_PIXEL = 'ttd_pixel',
  TWITTER = 'twitter',
  EMARSYS = 'emarsys',
  ONETRUST = 'onetrust',
  IMPACT_RADIUS = 'impactradius',
  AWIN = 'awin',
  GOOGLE_TRANSLATE = 'google_translate',
  GOOGLE_BADGE = 'google_badge',
  RTB_HOUSE = 'rtb_house',
  AWS_WAF = 'aws_waf',
  CONSENT_MANAGER = 'consent_manager',
  ARMS = 'arms',
  // Add other providers
}

export interface TrackingEvent {
  eventName?: string; // 事件名称
  commandType?: string; // 命令类型，在GA4或者Facebook会用到
  properties?: any;
  options?: Record<string, any>;
}

export interface Provider {
  type: ProviderType;
  isEnabled: boolean;
  init: () => Promise<boolean>;
  track: (event: TrackingEvent) => void;
  isInitialized: () => boolean;
}
